import { render, staticRenderFns } from "./idNumberTran.vue?vue&type=template&id=87b6fb48&scoped=true"
import script from "./idNumberTran.vue?vue&type=script&lang=js"
export * from "./idNumberTran.vue?vue&type=script&lang=js"
import style0 from "./idNumberTran.vue?vue&type=style&index=0&id=87b6fb48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b6fb48",
  null
  
)

export default component.exports